import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';


const AuthGuard = props => {
  const { children, fallback } = props
  const auth = useAuth()
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(
    () => {
      if (auth.loading) {
        return;
      }

      if (auth.user === null) {
        if (location.pathname !== '/') {
          navigate({
            pathname: '/login',
            search: `?returnUrl=${location.pathname}`,
            replace: true
          });
        } else {
          navigate('/login', { replace: true })
        }
      }
    }, [location.pathname, auth.loading]
  )
  if (auth.loading || auth.user === null) {
    return fallback
  }

  return <>{children}</>
}

export default AuthGuard
